import * as React from 'react';

export const Timer = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.8496 13.25C19.8496 8.91706 16.3329 5.40039 12 5.40039C7.66706 5.40039 4.15039 8.91706 4.15039 13.25C4.15039 17.5829 7.66706 21.0996 12 21.0996C16.3329 21.0996 19.8496 17.5829 19.8496 13.25ZM21.6504 13.25C21.6504 18.5771 17.3271 22.9004 12 22.9004C6.67294 22.9004 2.34961 18.5771 2.34961 13.25C2.34961 7.92294 6.67294 3.59961 12 3.59961C17.3271 3.59961 21.6504 7.92294 21.6504 13.25Z"
      fill="#64748B"
    />
    <path
      d="M11.0996 13V8C11.0996 7.50294 11.5029 7.09961 12 7.09961C12.4971 7.09961 12.9004 7.50294 12.9004 8V13C12.9004 13.4971 12.4971 13.9004 12 13.9004C11.5029 13.9004 11.0996 13.4971 11.0996 13Z"
      fill="#64748B"
    />
    <path
      d="M15 1.09961C15.4971 1.09961 15.9004 1.50294 15.9004 2C15.9004 2.49706 15.4971 2.90039 15 2.90039H9C8.50294 2.90039 8.09961 2.49706 8.09961 2C8.09961 1.50294 8.50294 1.09961 9 1.09961H15Z"
      fill="#64748B"
    />
  </svg>
);
